import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './GithubContributions';
import { styles } from './GithubContributions.styles';

const GithubContributions = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { GithubContributions };
